import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7e035a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-container" }
const _hoisted_2 = {
  ref: "scrollContainerRef",
  class: "content-wrapper",
  "aria-label": "문의글 작성"
}
const _hoisted_3 = { class: "checkbox-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createVNode($setup["VocEditGuideMessage"], { htmlText: "(<span class='emphasis'> * </span>)는 필수 입력 사항입니다." }),
      ($setup.vocTypeFilter)
        ? (_openBlock(), _createBlock($setup["LabeledCustomSelect"], {
            key: 0,
            class: "select-container",
            label: "문의유형",
            required: true,
            filter: $setup.vocTypeFilter,
            disabled: !!$setup.vocUid,
            placeholder: "선택",
            onOnSelectOption: $setup.onSelectOption
          }, null, 8 /* PROPS */, ["filter", "disabled"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["TextInput"], {
        class: "input-container",
        name: "title",
        placeholder: "제목을 입력하세요",
        label: "제목",
        required: true,
        value: $props.vocDetail?.title,
        "onUpdate:value": $setup.onUpdateTitle
      }, null, 8 /* PROPS */, ["value"]),
      _createElementVNode("div", null, [
        ($setup.boardedLineFilter)
          ? (_openBlock(), _createBlock($setup["LabeledCustomSelect"], {
              key: 0,
              class: "select-container",
              label: "노선",
              filter: $setup.boardedLineFilter,
              placeholder: "선택",
              onOnSelectOption: $setup.onSelectOption
            }, null, 8 /* PROPS */, ["filter"]))
          : _createCommentVNode("v-if", true),
        ($setup.shouldShowLineDirectInput)
          ? (_openBlock(), _createBlock($setup["TextInput"], {
              key: 1,
              class: "input-container board-line",
              name: "lineName",
              placeholder: "탑승노선을 입력하세요",
              value: $props.vocDetail?.lineName,
              "onUpdate:value": $setup.updateBoardedLineName
            }, null, 8 /* PROPS */, ["value"]))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.boardedLineFilter)
        ? (_openBlock(), _createBlock($setup["TargetCalendarInput"], {
            key: 1,
            class: "calendar-container",
            title: "일시",
            selectedDate: $props.vocDetail?.boardDtm,
            placeholder: "탑승일시를 선택하세요",
            dateFormat: "YYYY-MM-DD HH:mm",
            hasTimeSelect: true,
            "aria-label": "탑승 일시 선택",
            onOnSelectDate: $setup.changeDate
          }, null, 8 /* PROPS */, ["selectedDate"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["BaseTextarea"], {
        class: "textarea-container",
        placeholder: "내용을 입력하세요",
        label: "내용",
        required: true,
        value: $props.vocDetail?.bodyText,
        onOnInput: $setup.onUpdateBodyText
      }, null, 8 /* PROPS */, ["value"]),
      _withDirectives(_createVNode($setup["VocFileUploader"], {
        label: "첨부파일",
        editMode: $props.editMode,
        vocDetail: $props.vocDetail,
        onOnAddedFiles: $setup.addInputFiles,
        onOnDeletedFiles: $setup.deleteFileInfo
      }, null, 8 /* PROPS */, ["editMode", "vocDetail"]), [
        [_vShow, !$setup.isLostCategorySelected]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["CheckboxInput"], {
          class: "checkbox",
          title: "비밀글로 문의하기",
          value: $props.vocDetail?.secretYn,
          onOnChangedCheck: $setup.toggleSecret
        }, null, 8 /* PROPS */, ["value"]),
        ($setup.isLostCategorySelected)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "lost-guide-btn",
              type: "button",
              "aria-label": "분실물 안내 창 열기",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowLostItemGuide(true)))
            }, " 분실물 안내 "))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.scrollContainerRef)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 2,
            container: $setup.scrollContainerRef,
            class: "scroll-top-btn"
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */),
    _createVNode($setup["FooterButton"], {
      title: $setup.footerBtnTitle,
      disabled: !$setup.isValidRequiredFields,
      "aria-label": $setup.getFooterButtonAriaLabel(),
      onOnClickFooterButton: $setup.submitPost
    }, null, 8 /* PROPS */, ["title", "disabled", "aria-label"]),
    _createCommentVNode(" 분실물 안내 이미지 팝업 "),
    ($setup.shouldShowLostItemGuide)
      ? (_openBlock(), _createBlock($setup["LostItemGuideModal"], {
          key: 0,
          role: "dialog",
          "aria-modal": "true",
          onOnClickCloseButton: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowLostItemGuide(false)))
        }))
      : _createCommentVNode("v-if", true)
  ]))
}